import apiErrorMappings from '../constants/api-error-mappings'

const handleApiValidation = (errors) => {
      const fieldWithErrors = Object.keys(errors)
      const errorsObj = {}

      fieldWithErrors.forEach((field) => {
        errorsObj[field] = apiErrorMappings[field][errors[field][0]]
      })

      return errorsObj
}

export default handleApiValidation
